import { useCallback, useMemo } from "react";
import { MdOutlineArrowDropDown } from "react-icons/md";
import { Dropdown } from "antd";
import { Link } from "react-router";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { FaUserEdit } from "react-icons/fa";
import { useLogout } from "queries/user";
import Avatar from "./Avatar";
import { useSelector } from "react-redux";
import {
  apiTokenSelector,
  isAgentOnlineSelector,
  userSelector,
} from "appredux/selectors";
import { useTranslation } from "react-i18next";
import Text from "components/UI/Text";
import { getRefreshToken, getToken } from "utils/cookies";
import { turnOfflineLogout } from "apis/user";

const ProfileMenu = () => {
  const { t } = useTranslation();
  const mutationLogout = useLogout();
  const user = useSelector(userSelector);
  const isOnline = useSelector(isAgentOnlineSelector);
  const apiToken = useSelector(apiTokenSelector);

  const logoutHandler = useCallback(() => {
    // Utamakan token di cookie: apiToken di redux bisa sudah usang setelah refresh token
    const token = getToken() || apiToken || null;
    const payload = { token, refreshToken: getRefreshToken() };

    try {
      if (isOnline === 1) {
        turnOfflineLogout(token);
        if (token) {
          mutationLogout.mutate(payload);
        }
      } else {
        mutationLogout.mutate(payload);
      }
    } catch (error) {
      console.log(error);
      mutationLogout.mutate(payload);
    }
  }, [mutationLogout, isOnline, apiToken]);

  const menuItems = useMemo(() => {
    const items = [
      {
        key: "topBar.profileMenu.hello",
        label: <strong>Hello, {user?.name}</strong>,
        icon: <UserOutlined />,
      },
    ];

    items.push(
      {
        key: "divider-2",
        type: "divider",
      },
      {
        key: "topBar.profileMenu.email",
        label: (
          <div>
            <strong>Email: </strong>
            {user?.email}
            <br />
            <strong>Handphone: </strong>
            {user?.phone_number}
            <br />
            <Text className="text-gray-400">{`v${
              import.meta.env.PACKAGE_VERSION
            }`}</Text>
          </div>
        ),
      },
      {
        key: "divider-5",
        type: "divider",
      },
      {
        key: "topBar.profileMenu.editProfile",
        label: (
          <Link to="/settings/profile">
            {t("topBar.profileMenu.editProfile")}
          </Link>
        ),
        icon: <FaUserEdit size={15} />,
      },
      {
        key: "divider-7",
        type: "divider",
      },
      {
        key: "topBar.profileMenu.logout",
        label: "Logout",
        icon: <LogoutOutlined />,
        onClick: logoutHandler,
      }
    );

    return items;
  }, [logoutHandler, t, user?.email, user?.name, user?.phone_number]);

  return (
    <>
      <Dropdown
        overlayClassName="pt-4"
        placement="bottomRight"
        menu={{ items: menuItems, selectable: false }}
        trigger={["click"]}
      >
        <div className="flex flex-row items-center gap-1 cursor-pointer">
          <Avatar imageUrl={user?.profile_image} />
          <MdOutlineArrowDropDown />
        </div>
      </Dropdown>
    </>
  );
};

export default ProfileMenu;
